import { makeStyles, Theme, createStyles, withStyles } from '@material-ui/core/styles';
import { orange, pink, red } from '@material-ui/core/colors';
import { InputBase } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    backgroundColor: '#ffffff',
    padding: theme.spacing(3),
    boxShadow: theme.shadows[0],
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  papers: { padding: 22, borderRadius: 8, boxShadow: 'none', border: '1px solid #e7eaf0', background: '#fff' },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 18,
    gap: 12,
  },
  heading: { display: 'flex', alignItems: 'baseline', gap: 12 },
  exportButton: {
    background: '#0877f9',
    color: '#fff',
    fontWeight: 600,
    boxShadow: 'none',
    '&:hover': { background: '#0065d9' },
  },
  filters: {
    display: 'grid',
    gridTemplateColumns: 'minmax(200px, 1.6fr) repeat(3, minmax(140px, 1fr))',
    gap: 10,
    marginBottom: 12,
    [theme.breakpoints.down('sm')]: { gridTemplateColumns: '1fr 1fr' },
    [theme.breakpoints.down('xs')]: { gridTemplateColumns: '1fr' },
  },
  filterField: {
    '& .MuiOutlinedInput-root': { borderRadius: 6, height: 40, fontSize: 13 },
    '& .MuiSelect-select': { paddingTop: 11, paddingBottom: 11 },
  },
  meta: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 8,
    fontSize: 11,
    color: '#667085',
    paddingBottom: 14,
    borderBottom: '1px solid #e9edf3',
  },
  day: { marginTop: 14, marginBottom: 7, color: '#667085', fontWeight: 600, fontSize: 12 },
  event: { display: 'flex', position: 'relative', gap: 13, padding: '6px 0 10px', minHeight: 55 },
  iconColumn: { width: 28, flexShrink: 0, position: 'relative', display: 'flex', justifyContent: 'center' },
  line: { position: 'absolute', top: 29, bottom: -14, width: 1, background: '#e4e9f1', left: '50%' },
  icon: {
    width: 26,
    height: 26,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
  },
  blue: { color: '#367bff', background: '#edf3ff' },
  red: { color: '#f04452', background: '#fff0f1' },
  body: { flex: 1, minWidth: 0 },
  eventTitle: { fontSize: 13, fontWeight: 600, color: '#202633' },
  byline: { fontSize: 11, color: '#7b8494', marginTop: 4 },
  detailsLink: {
    display: 'inline-block',
    fontSize: 11,
    color: '#1769f4',
    cursor: 'pointer',
    marginTop: 7,
    border: 0,
    padding: 0,
    background: 'transparent',
    '&:hover': { textDecoration: 'underline' },
  },
  detailBox: {
    marginTop: 9,
    padding: 12,
    borderRadius: 6,
    background: '#f8faff',
    border: '1px solid #e9effa',
    fontSize: 12,
    color: '#475467',
    overflowWrap: 'anywhere',
  },
  detailRow: { marginBottom: 5 },
  right: { width: 128, flexShrink: 0, textAlign: 'right', [theme.breakpoints.down('xs')]: { width: 90 } },
  chip: { height: 23, fontSize: 10, background: '#eceef1', color: '#424956' },
  footer: { display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #eef0f4', marginTop: 12 },
  count: { color: '#667085', fontSize: 12 },
  descriptions: { fontSize: 12, color: '#4b5565', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', marginTop: 3 },
  links: { color: '#1769f4', cursor: 'pointer', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } },

  value: {
    fontSize: 34,
    marginBottom: theme.spacing(1),
  },
  yesValue: {
    fontSize: 20,
  },
  title: {
    flexGrow: 1,
    maxWidth: 280,
    //height: 60,
    fontSize: 16,
    marginBottom: theme.spacing(3),
    color: '#757575',
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(4),
  },
  gridPaper: {
    height: '140px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    position: 'relative',
    padding: '16px',
    boxSizing: 'border-box',
  },
  // paper: {
  //   padding: theme.spacing(2),
  //   display: 'flex',
  //   overflow: 'auto',
  //   flexDirection: 'column',
  // },
  infoContainer: {
    display: 'flex',
    marginBottom: theme.spacing(1),
    alignItems: 'stretch',
  },

  inputTwo: {
    color: 'rgb(0 0 0 / 87%)',
    width: '100%',
    '& .MuiInputBase-input': {
      padding: '18px 6px',
    },
    '& label': {
      transform: 'translate(0, 0)',
      '& + div': {
        margin: 0,
      },
    },
    '& .MuiPhoneNumber-flagButton': {
      marginTop: '15px',
    },
  },
  searchInput: {
    borderRadius: 4,
    width: '100%',
    height: 50,
  },
  noBorder: {
    border: 'none',
  },
  btnAdd: {
    boxShadow: theme.shadows[0],
    padding: theme.spacing(1, 1),
    marginLeft: theme.spacing(2),
    minWidth: 64,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#fff',
    '& .MuiInput-underline': {
      '&:before': {
        display: 'none',
      },
      padding: `0 ${theme.spacing(1.5)}px 1px ${theme.spacing(1.5)}px`,
      '&:after': {
        display: 'none',
      },
    },
    '& .MuiInputBase-input': {
      padding: `0 ${theme.spacing(1)}px 1px ${theme.spacing(1)}px`,
      '&::-webkit-input-placeholder': {
        color: theme.palette.text.primary,
        fontSize: 14,
      },
      '&::-moz-placeholder': {
        color: theme.palette.text.primary,
        fontSize: 14,
      },
      '&:-moz-placeholder': {
        color: theme.palette.text.primary,
        fontSize: 14,
      },
      '&:-ms-input-placeholder': {
        color: theme.palette.text.primary,
        fontSize: 14,
      },
    },
  },
  centerHeadBox: {
    flexGrow: 1,
    margin: `0 ${theme.spacing(2)}px`,
  },
  textBox: {
    marginBottom: theme.spacing(2),
    fontSize: 14,
    color: 'rgb(0 0 0 / 54%)',
  },
  dataGrid: {
    width: '100%',
    '& .MuiDataGrid-root .MuiDataGrid-row.Mui-selected ': {},
    '& .MuiDataGrid-root .MuiDataGrid-row': {
      '&:hover': {
        backgroundColor: 'rgba(255, 80, 95, 0.04)',
      },
    },
    '& .row-background-error': {
      backgroundColor: red[50],
      '&:hover': {
        backgroundColor: red[100],
      },
    },
    '& .row-background-alert': {
      backgroundColor: pink[50],
      '&:hover': {
        backgroundColor: pink[100],
      },
    },
    '& .row-background-transaction': {
      backgroundColor: 'white',
      '&:hover': {
        backgroundColor: 'rgba(255, 80, 95, 0.04)',
      },
    },
    '& .cell-text-color-error': {
      color: pink[700],
    },
    '& .cell-text-color-alert': {
      color: orange[700],
    },
    '& .cell-text-color-transaction': {
      color: 'black',
      fontWeight: '500',
      textTransform: 'capitalize',
    },
    '& .MuiDataGrid-colCellTitle': {
      color: 'black',
      fontWeight: '700',
      textTransform: 'capitalize',
    },
    marginBottom: '10px',
    padding: '10px',
  },
  leftCol: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: '24px',
  },
  search: {
    //margin: theme.spacing(2),
    width: '50%',
  },
  input: {
    width: '100%',
    color: 'rgb(0 0 0 / 87%)',
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  submitBtn: {
    padding: theme.spacing(1, 5),
    fontSize: 14,
    whiteSpace: 'nowrap',
    backgroundColor: '#E2222B',
    fontWeight: 500,
    lineHeight: '26px',

    letterSpacing: '0.46px',
    textTransform: 'capitalize',

    color: '#FFFFFF',
  },
  link: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '100px',
    flexGrow: 1,
    fontWeight: 600,
    fontFamily: 'Roboto',
    fontSize: '20px',
    lineHeight: '27px',
  },
  border: {
    border: '1px solid #E0E0E0',
  },
  boxes: {
    width: '80% !important',
  },
  tableCheck: {
    padding: '0 !important',
  },
  cellTitle: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  titleLink: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '18px',
    color: '#5081FF',
    cursor: 'pointer',
  },
  cellLink: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    color: '#5081FF',
    cursor: 'pointer',
    '& .MuiInputBase-input': {
      color: '#5081FF',
    },
  },
  cellInputLink: {
    '& .MuiInputBase-input': {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      color: '#5081FF',
    },
  },
  row: {
    position: 'relative',
    alignItems: 'center',
  },
  mappingSubText: {
    fontSize: '14px',
    color: '#6b7280', // soft gray
    marginTop: '4px',
  },
  selectBlock: {
    width: '100%',
    padding: theme.spacing(1, 1, 1, 3),
    border: '1px solid #E0E0E0',
    borderRadius: '4px',

    '& > div': {
      background: 'transparent',
    },
    '&::before': {
      display: 'none',
    },
    '&::after': {
      display: 'none',
    },
  },
  selectIcon: {
    marginRight: theme.spacing(1.1),
  },
  mappingHeader: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2, 3),
  },
  mappingTitle: {
    fontSize: '24px',
    fontWeight: 600,
    color: 'rgba(0, 0, 0, 0.87)',
    margin: 0,
    letterSpacing: '0.15px',
  },

  //   paper: {
  //   padding: theme.spacing(2),
  //   marginBottom: theme.spacing(2),
  //   width: '100%',
  // },
  // title: {
  //   marginBottom: theme.spacing(2),
  //   fontWeight: 600,
  //   color: theme.palette.primary.main,
  // },
  list: {
    overflow: 'auto',
  },
  listItem: {
    padding: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  primaryText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
  },
  typeChip: {
    height: '20px',
    fontSize: '0.75rem',
  },
  secondaryText: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  description: {
    marginTop: theme.spacing(0.5),
    fontStyle: 'italic',
  },
  loading: {
    textAlign: 'center',
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(3),
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    gap: theme.spacing(1),
  },
}));

export const useStylesSecond = makeStyles((theme: Theme) => ({
  label: {
    minWidth: 'auto',
    maxWidth: 'inherit',
    padding: 0,
    fontWeight: 500,
    fontSize: 14,
  },

  title: {
    flexGrow: 1,
    fontSize: 14,
    margin: theme.spacing(1),
  },
  gridPaper: {
    height: '100%',
  },
  tabsPaper: {
    width: '100%',
    boxShadow: theme.shadows[0],
    backgroundColor: 'transparent',
    '& [class*="MuiBox-root"]': {
      padding: theme.spacing(2, 0, 0, 0),
    },
  },
  tabsPanel: {
    padding: 12,
    width: '100%',
  },
  tabsPanels: {
    padding: 24,
    width: '100%',
  },
  tabBox: {
    //backgroundColor: '#ffffff',
    //marginTop: theme.spacing(2.5),
  },
  tab: {
    //backgroundColor: '#ffffff',
    marginTop: theme.spacing(2.5),
  },
  container: {
    width: '100%',
  },
  row: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(3.5),
  },
  titlePopSmtp: {
    width: 170,
    margin: theme.spacing(0, 5, 0, 0),
    color: 'rgb(0 0 0 / 87%)',
  },
  desc: {
    width: 320,
    borderBottom: '1px solid #E0E0E0',
    padding: 5,
    color: 'rgb(0 0 0 / 87%)',
  },
  tabs: {
    width: 'fit-content',
    border: '1px solid white',
    borderRadius: '4px 0px 0px 4px',
    background: 'white',
    '& .MuiTabs-indicator': {
      backgroundColor: 'orange',
      height: 3,
    },
    '& .MuiTab-root.Mui-selected': {
      color: 'white',
      backgroundColor: '#5081FF',
    },
    '& .MuiTab-root': {
      padding: '16px 24px',
    },
  },
  badge: {
    position: 'relative',
    left: theme.spacing(-2),
  },
}));
export const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
    },
    input: {
      width: theme.spacing(20),
      borderRadius: '4px 0 0 4px',
      position: 'relative',
      background: theme.palette.action.hover,
      fontSize: 14,
      padding: 16,
    },
  })
)(InputBase);
